import { provide, inject, ref } from 'vue';
import { useForm } from 'vee-validate';

const requiredFormScope: string = 'RequiredForm';

function provideValidationSchema(schema: any): void {
    provide<any>(requiredFormScope, schema);
}

export function isRequiredField(name: string, schema): boolean {
    const unRefSchema = schema.value || schema;
    const hasString = name && unRefSchema[name] && typeof unRefSchema[name] === 'string' && unRefSchema[name].includes('required');
    const hasExpression = name && unRefSchema[name] && unRefSchema[name].required;
    return hasString || hasExpression;
}

export function getMaybeRequiredLabel(name: string, schema, label: string): string {
    return isRequiredField(name, schema) ? `${label} *` : label;
}

export function useValidationSchema() {
    const schema = inject(requiredFormScope, ref({}));
    return schema;
}

export function useRequiredForm(options) {
    if (options.validationSchema) {
        provideValidationSchema(options.validationSchema);
    }
    return useForm(options);
}
